<template>
  <div class="header">
    <h1>用戶管理 - {{ displayName }}</h1>
  </div>

  <div>
    <div class="user-img" @click="showPhoto = true" style="cursor: pointer">
      <CImage v-if="image" width="150" rounded height="150" :src="image" />
      <CImage v-else :src="require(`@/assets/icons/user.svg`)" />
    </div>
    <CropPicture
      :show="showPhoto"
      @close="showPhoto = false"
      @image="image = $event"
    />
  </div>
  <div
    class="text-center d-flex align-items-center justify-content-center mb-5"
  >
    <div class="position-relative d-flex align-items-center">
      <span class="text-danger me-1">*</span>
      <input
        :class="editName ? 'active' : ''"
        :disabled="!editName"
        v-model="name"
        class="edit-name"
      />
      <img
        v-if="editName"
        @click="editName = false"
        style="cursor: pointer"
        class="position-absolute edit-name-img"
        src="@/assets/icons/edit-blue.svg"
        alt=""
      />
      <img
        v-else
        @click="editName = true"
        style="cursor: pointer"
        class="position-absolute edit-name-img"
        src="@/assets/icons/edit-black.svg"
        alt=""
      />
    </div>
  </div>
  <span class="text-danger">* 為必填</span>
  <div
    v-for="item in userInfo"
    :key="item"
    class="position-relative d-flex align-items-center justify-content-between pt-4 col-12"
  >
    <span class="text-nowrap col-1 text-center">
      <span
        class="text-danger"
        v-if="
          item.name !== 'company_address' &&
          item.name !== 'company_phone' &&
          item.name !== 'official_website' &&
          item.name !== 'username'
        "
        >*</span
      >
      {{ item.label }}</span
    >
    <input
      v-if="(item.name !== 'company_phone' && item.name !== 'mobile')"
      :disabled="item.label === '登入帳號'"
      class="rounded-pill border info col-11"
      v-model="item.value"
      :placeholder="item.placeholder"
    />
    <input
        v-else
        class="rounded-pill border info col-11"
        v-model="item.value"
        :placeholder="item.placeholder"
        @change="ChangeNumber"
        oninput="value=value.replace(/^\D*([0-9]\d*\.?\d{0,2})?.*$/,'$1')"
      />
    <img
      v-if="item.label === '登入密碼'"
      class="position-absolute copy"
      src="@/assets/icons/open-eye.svg"
      alt=""
    />
  </div>

  <div
    class="position-relative d-flex align-items-center justify-content-between pt-4 col-12"
  >
    <span class="text-nowrap col-1 text-center">最後登入</span>
    <div class="rounded-pill col-11 border info opacity-75">
      {{ formatTimestamp(getInfo?.lasted) }}
    </div>
  </div>
  <div
    class="position-relative d-flex align-items-center justify-content-between pt-4 pb-5 col-12"
  >
    <span class="text-nowrap col-1 text-center">
      <span class="text-danger me-1">*</span>
      用戶狀態</span
    >
    <select v-model="state" class="rounded-pill info col-11 border">
      <option
        v-for="option in options"
        :value="option.value"
        :key="option.value"
      >
        {{ option.text }}
      </option>
    </select>
  </div>
  <div class="col-12 d-flex align-items-center justify-content-center">
    <button
      @click="showDeleteBox = true"
      class="btn btn-outline-warning user-btn rounded-pill col-3 me-2"
    >
      刪除此用戶
    </button>
    <button
      @click="showChangePassword = true"
      class="btn btn-outline-primary user-btn rounded-pill col-3 mx-4"
    >
      修改密碼
    </button>
    <button
      @click="submit"
      :disabled="!isPassed"
      class="btn btn-outline-primary user-btn rounded-pill col-3 ms-2"
    >
      完成
    </button>
  </div>
  <MsgBox :show="showMsgBox" :errorMsg="errorMsg" @close="showMsgBox = false" />
  <ChangePassword
    :show="showChangePassword"
    :name="name"
    @close="showChangePassword = false"
  />
  <DeleteBox
    :show="showDeleteBox"
    :id="$route.params.id"
    @confirm="deleteUser"
    @close="showDeleteBox = false"
  />
</template>
<script>
import { ref } from '@vue/reactivity'
import useInfo from '@/composables/useInfo'
import { useRoute } from 'vue-router'
import MsgBox from '@/components/MsgBox.vue'
import ChangePassword from '@/components/ChangePassword.vue'
import { computed, watch } from '@vue/runtime-core'
import DeleteBox from '@/components/DeleteBox.vue'
import { formatDateFullToMinute } from '@/utils/format-date.js'
import { copyText } from 'vue3-clipboard'
import CropPicture from '@/components/CropPicture.vue'
import router from '@/router'
import verifyForm from '@/utils/verifyForm'
import { User_Is_True, User_Is_False } from '../defines'

export default {
  components: {
    MsgBox,
    ChangePassword,
    DeleteBox,
    CropPicture,
  },
  setup() {
    const { getSignList, signEdit, signDelete } = useInfo()
    const showMsgBox = ref(false)
    const errorMsg = ref('')
    const route = useRoute()
    const enterpriseList = ref([])
    const showChangePassword = ref(false)
    const state = ref('1')
    const errorCode = ref('')
    const showDeleteBox = ref(false)
    const editName = ref(false)
    const image = ref('')
    const showPhoto = ref(false)
    const isPassed = computed(() => {
      const requiredField = [
        'uniform_numbers',
        'email',
        'username',
        'company_name',
        'contact_person',
        'mobile',
        'state',
      ]
      return requiredField.every((key) => {
        return formData.value[key]
      })
    })
    const getList = async () => {
      const res = await getSignList({ page: route.query.currentPage || '' })
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        enterpriseList.value = res.ret.data
      }
    }

    const deleteUser = async () => {
      const res = await signDelete({ id: route.params.id })
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        await getList()
      }
      router.replace('/user-management/user-enterprise-list/')
      showDeleteBox.value = false
    }

    getList()
    const getInfo = computed(() => {
      return enterpriseList.value.find((e) => {
        return e.id === route.params.id
      })
    })
    const options = ref([
      { text: '啟用', value: User_Is_True },
      { text: '凍結', value: User_Is_False },
    ])
    const name = ref('')
    const displayName = ref('')
    const userInfo = ref([
      { label: '企業地址' },
      { label: '企業電話' },
      { label: '統一編號' },
      { label: '官方網站' },
      { label: '郵件地址' },
      { label: '聯絡人' },
      { label: '聯絡電話' },
      { label: '登入帳號' },
    ])
    const formatTimestamp = (timestamp) => {
      return timestamp === 0
        ? '暫無登入記錄'
        : formatDateFullToMinute(timestamp * 1000)
    }
    watch(getInfo, () => {
      name.value = getInfo.value?.company_name
      displayName.value = getInfo.value?.company_name
      state.value = getInfo.value?.state
      userInfo.value = [
        {
          name: 'company_address',
          label: '企業地址',
          value: getInfo.value?.company_address,
          placeholder: '請輸入企業地址 例：臺北市大安區忠孝東路4段218之1號10樓',
        },
        {
          name: 'company_phone',
          label: '企業電話',
          value: getInfo.value?.company_phone,
          placeholder: '請輸入企業電話 例：02-87715543',
        },
        {
          name: 'uniform_numbers',
          label: '統一編號',
          value: getInfo.value?.uniform_numbers,
          placeholder: '請輸入統一編號 例：24939462',
        },
        {
          name: 'official_website',
          label: '官方網站',
          value: getInfo.value?.official_website,
          placeholder: '請輸入官方網站 例：https://www.google.com',
        },
        {
          name: 'email',
          label: '郵件地址',
          value: getInfo.value?.email,
          placeholder: '請輸入郵件地址 例：service@gmail.com',
        },
        {
          name: 'contact_person',
          label: '聯絡人',
          value: getInfo.value?.contact_person,
          placeholder: '請輸入聯絡人 例：王小明',
        },
        {
          name: 'mobile',
          label: '聯絡電話',
          value: getInfo.value?.mobile,
          placeholder: '請輸入聯絡電話 例：0912345678',
        },
        {
          name: 'username',
          label: '登入帳號',
          value: getInfo.value?.username,
          placeholder: '請輸入至少五位數登入帳號 ',
        },
      ]
    })

    const formData = computed(() => {
      const info = userInfo.value.reduce(function (target, key) {
        target[key.name] = key.value
        return target
      }, {})
      info.id = route.params.id
      info.state = state.value
      info.company_name = name.value
      info.avatar_image = image.value
      return info
    })

    const submit = async () => {
      const rules = {
        company_phone: '^(0[0-9]{1}-)?([0-9]{6,8})+(#[0-9]{1,4})?$',
        uniform_numbers: '^[0-9]{8}$',
      }
      const errorMessages = {
        company_phone: '企業電話格式錯誤',
        uniform_numbers: '統一編號格式錯誤',
      }
      const passed = verifyForm(formData.value, rules, errorMessages)
      if (passed.error) {
        showMsgBox.value = true
        errorMsg.value = passed.errorMessage
        return
      }
      const res = await signEdit(formData.value)
      if (res.error) {
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        showMsgBox.value = true
        errorMsg.value = '編輯成功'
        router.push('/user-management/user-enterprise-list')
      }
    }
    const doCopy = (text) => {
      copyText(text, undefined, (error) => {
        if (error) {
          showMsgBox.value = true
          errorMsg.value = '複製失敗，請再複製一次。'
          errorCode.value = ''
        } else {
          showMsgBox.value = true
          errorMsg.value = '複製成功'
          errorCode.value = ''
        }
      })
    }
    const ChangeNumber = ($event) => {
      if ($event?.target?.value) {
        $event.target.value = `${Number($event.target.value)}`
      }
    };
    return {
      userInfo,
      options,
      showMsgBox,
      errorMsg,
      enterpriseList,
      name,
      state,
      showChangePassword,
      errorCode,
      submit,
      formatTimestamp,
      showDeleteBox,
      getInfo,
      displayName,
      editName,
      doCopy,
      image,
      showPhoto,
      isPassed,
      deleteUser,
      formData,
      ChangeNumber
    }
  },
}
</script>
<style lang="scss" scoped>
.header {
  padding: 40px 0px;
}
h1 {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
  color: #000000;
}
.user-img {
  width: 160px;
  height: 160px;
  border: 1px #eff0f6 solid;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 64px auto 16px;
}
.info {
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 60px 0 32px;
  outline-color: #d1e5ef;
  color: #4d4d4d;
}
input::placeholder {
  font-size: 16px;
}
select {
  background: url('~@/assets/icons/arrow-down.svg') no-repeat scroll 97% center
    transparent;
  appearance: none;
  color: #4d4d4d;
}

.copy {
  right: 32px;
}

.user-btn {
  height: 48px;
  margin: 24px 0 72px 0;
}
.edit-name {
  border: 1px #eff0f6 solid;
  border-radius: 5px;
  width: 160px;
}
.edit-name-img {
  right: -22px;
}
.active {
  border: 1px solid #177baf;
  outline-color: #177baf;
}
</style>
